import { useEffect } from "react";

interface MetaOptions {
  title: string;
  description?: string;
  keywords?: string;
}

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  if (typeof document === "undefined") return;
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useDocumentMeta({ title, description, keywords }: MetaOptions) {
  useEffect(() => {
    if (typeof document === "undefined") return;
    document.title = title;
    upsertMeta("property", "og:title", title);
    if (description) {
      upsertMeta("name", "description", description);
      upsertMeta("property", "og:description", description);
    }
    if (keywords) {
      upsertMeta("name", "keywords", keywords);
    }
  }, [title, description, keywords]);
}